<template>
  <div class="h-full px-8 py-16 flex flex-col items-center justify-center">
    <Image src="empty_search" alt="not_found" class="pb-4" />

    <NText weight="bold" variant="body" tag="p">
      {{ t('search.not_found', { term }) }}
    </NText>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

import Image from '@/components/Image.vue';

type SymbolSearchEmptyPropsType = {
  term: string;
};

defineProps<SymbolSearchEmptyPropsType>();

const { t } = useI18n();
</script>
